import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchRoles as fetchRolesAPI } from "services/api/users";
import { AuthState } from "slices/auth/reducer";
import { ERROR } from "types";
import { UserRole } from "types/users";
import { getErrorMessage, isFresh } from "utils/helpers";
import { Roles } from "./reducer";
import apiConfig from "constants/apiConfig";

const STALE_TIME = apiConfig.FETCH_ROLES.staleTime;

export const fetchRoles = createAsyncThunk<UserRole[], boolean, { rejectValue: string }>(
    'a/roles',
    async (force = false, { getState, rejectWithValue }) => {
        const state = getState() as { roles: Roles, auth: AuthState };
        if (!force &&
            isFresh(state.roles.last_fetched_at, STALE_TIME)
        ) {
            return rejectWithValue(ERROR.CACHED)
        }
        try {
            const roles = await fetchRolesAPI();
            return roles;
        } catch (error) {
            return rejectWithValue(getErrorMessage(error, ERROR.NOT_FOUND));
        }
    }
)